<template>
	<common-dialog ref="dialog" color="error" :component="$options.name">
		<template #header>
			Restrict Providers Filter
		</template>
		<template #body>
			<p class="text-body-1">
				The 'Restrict Providers' filter was used during this sourcing session. Should you wish, you can supply a summary of why those Providers were restricted. This
				summary will then be printed alongside your Research PDF.
			</p>
			<validation-observer v-slot="{ invalid, validate }">
				<form @submit.prevent="validate().then(submit)">
					<validation-provider v-slot="{ errors }" name="Reason" rules="required">
						<v-textarea v-model="reason" rows="3" :error-messages="errors" label="Providers were restricted due to ..." outlined />
					</validation-provider>
					<div class="d-flex">
						<v-btn color="primary" class="mr-4" type="submit" :disabled="invalid">
							{{ download ? 'Submit and Download PDF' : 'Submit' }}
						</v-btn>
						<v-btn color="secondary" outlined @click="skip">
							{{ download ? 'Skip and Download PDF' : 'Skip' }}
						</v-btn>
					</div>
				</form>
			</validation-observer>
		</template>
	</common-dialog>
</template>

<script>
	import { ValidationObserver, ValidationProvider } from 'vee-validate';
	import CommonDialog from '@/component/common/dialog';

	export default {
		name: 'app-client-property-dialog-download-results',

		components: { ValidationObserver, ValidationProvider, CommonDialog },

		props: {
			download: { type: Boolean, default: false }
		},

		data() {
			return {
				reason: null
			};
		},

		methods: {
			open(text) {
				this.reason = text || null;
				this.$refs.dialog.open();
			},

			close() {
				this.$refs.dialog.close();
			},

			submit() {
				if (this.download) this.$emit('download-document', { restrictedProviderReason: this.reason });
				else this.$emit('restricted-provider-reason', this.reason, false);
				this.close();
			},

			skip() {
				if (this.download) this.$emit('download-document', undefined);
				else this.$emit('restricted-provider-reason', null, true);
				this.close();
			}

		}
	};
</script>
